export default {
  install (Vue) {
    Vue.directive('permission', {
      bind: function (el, binding) {
        const { module, subModule, action } = binding.value
        const permissions = getPermissions()
        console.log('Checking permission - module:', module, 'subModule:', subModule, 'action:', action)

        const hasPerm = checkPermission(permissions, module, subModule, action)
        console.log('Permission result:', hasPerm)
        if (!hasPerm) {
          el.style.display = 'none'
        }
      },
      update: function (el, binding) {
        const { module, subModule, action } = binding.value
        const permissions = getPermissions()
        console.log('Updating permission - module:', module, 'subModule:', subModule, 'action:', action)

        const hasPerm = checkPermission(permissions, module, subModule, action)
        console.log('Permission result:', hasPerm)
        if (!hasPerm) {
          el.style.display = 'none'
        } else {
          el.style.display = ''
        }
      }
    })
  }
}

function getPermissions () {
  try {
    const permStr = localStorage.getItem('adminPermissions')
    const perms = permStr ? JSON.parse(permStr) : {}
    console.log('Loaded permissions:', perms)
    return perms
  } catch (e) {
    console.error('Error loading permissions:', e)
    return {}
  }
}

function checkPermission (permissions, moduleName, subModuleName, action) {
  const cleanModuleName = moduleName.replace(/\s+/g, '')
  const cleanSubModuleName = (subModuleName || '').replace(/\s+/g, '')

  console.log('Checking permission: moduleName=' + moduleName + ', subModuleName=' + subModuleName + ', action=' + action)
  console.log('cleanModuleName=' + cleanModuleName + ', cleanSubModuleName=' + cleanSubModuleName)

  for (const key in permissions) {
    const cleanKey = key.replace(/\s+/g, '')
    console.log('Comparing key:', cleanKey, 'with module:', cleanModuleName)

    if (cleanKey === cleanModuleName) {
      const modulePerms = permissions[key]
      console.log('Found module permissions:', modulePerms)

      if (cleanSubModuleName && modulePerms[cleanSubModuleName]) {
        const hasSubPerm = modulePerms[cleanSubModuleName].includes(action)
        console.log('Checking subModule permission:', cleanSubModuleName, 'has action', action, ':', hasSubPerm)
        if (hasSubPerm) return true
      }

      if (modulePerms[''] && modulePerms[''].includes(action)) {
        console.log('Checking top-level permission, has action', action, ':', true)
        return true
      }

      console.log('No matching permission found for module')
      return false
    }
  }
  console.log('Module not found in permissions')
  return false
}
